import RcsPreview from 'components/messagePreview/components/RcsPreview';
import { MessageDirections } from 'components/messagePreview/constants';
import styled from 'styled-components';
import { RcsMessage } from 'types/rcs';

const MAX_WIDTH = 252;

const StyledWrapper = styled.div`
  max-width: ${MAX_WIDTH}px;
`;

interface ShopRcsMessageProps {
  carouselOverflowSize?: string;
  className?: string;
  rcsMessage?: RcsMessage;
}

const ShopRcsMessage = ({
  carouselOverflowSize,
  className,
  rcsMessage,
}: ShopRcsMessageProps) => {
  if (!rcsMessage) return null;
  return (
    <StyledWrapper className={className}>
      <RcsPreview
        carouselOverflowSize={carouselOverflowSize}
        direction={MessageDirections.OUTGOING}
        isLoading={false}
        message={rcsMessage}
      />
    </StyledWrapper>
  );
};

export default ShopRcsMessage;
